/* eslint-disable array-callback-return */
import React from 'react'
import moment from 'moment'
import { Collapse } from 'antd'
import { Avatar, List } from 'antd'
import './ListData.scss'
import Button from '../Button/Button'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import { getProjectById } from '../../utils/api/projectServices'
import { getCompanydetailsById } from '../../utils/api/companyServices'
import { useDispatch } from 'react-redux'
import { setCurrentCompanyId } from '../../redux/reducer/companyIdSlice'
import {
  headerItemLabels,
  DATE_FORMATS,
  headerItemMapping,
  PREDICTION_AND_INVOICES,
} from '../../utils/constants/constant'

const { Panel } = Collapse

// Target of the resource-type link (e.g. INVOICE, RATE) in an activity row.
const getResourceLinkPath = (resourceName, projectId) => {
  switch (resourceName) {
    case 'INVOICE':
    case 'PREDICTION':
      return `predictiondetails/${projectId}`
    case 'RATE':
    case 'SPECIAL_RATE':
      return `ratedetails/${projectId}`
    case 'PROJECT':
      return `projectdetails/${projectId}`
    case 'COMPANY':
      return `companydetails/${projectId}`
    case 'CLIENT':
      return 'companylist'
    default:
      return 'userlist'
  }
}

// Target of the project/entity-name link in an activity row.
const getProjectLinkPath = (resourceName, projectId) => {
  switch (resourceName) {
    case 'USER':
      return 'userlist'
    case 'CLIENT':
      return 'companylist'
    case 'COMPANY':
      return `companydetails/${projectId}`
    default:
      return `projectdetails/${projectId}`
  }
}

const getResourceLinkState = (resourceName) => ({
  activityRedirect: resourceName === 'INVOICE',
  sidebarSelected: resourceName === 'USER' && '6',
  headerSelectedItem:
    headerItemMapping[resourceName] || headerItemLabels.PROJECT_DETAILS,
  seletedTab:
    resourceName === 'INVOICE'
      ? PREDICTION_AND_INVOICES.allInvoices
      : PREDICTION_AND_INVOICES.predictions,
})

const toggleExpandedItem = (expandedItems, id) =>
  [...expandedItems].map((item) =>
    item?.id === id ? { ...item, value: !item?.value } : item
  )

const getExpandToggleLabels = (expandedItems, id) =>
  expandedItems?.map((item) => {
    if (item?.id !== id) return undefined
    return item?.value ? 'See Less...' : 'See More...'
  })

const ListData = ({ date, dataSource }) => {
  const [expanded, setexpanded] = useState(
    dataSource?.map((item) => {
      if (item?.simpleActivityLogs?.length)
        return {
          id: item?.id,
          value: false,
        }
    })
  )
  const dispatch = useDispatch()

  const handleResourceLinkClick = (resourceName, projectId) => {
    if (resourceName === 'COMPANY' || resourceName === 'CLIENT') {
      dispatch(setCurrentCompanyId(projectId))
      dispatch(getCompanydetailsById(projectId))
    } else {
      dispatch(getProjectById(projectId))
    }
  }

  const handleToggleExpanded = (id) => {
    setexpanded((prev) => toggleExpandedItem(prev, id))
  }

  return (
    <div className="list-items-wrap add-project">
      <Collapse accordion>
        <Panel header={moment(date).format(DATE_FORMATS.DD_MMM_YYYY)} key={[1]}>
          <List
            itemLayout="horizontal"
            dataSource={dataSource}
            renderItem={({
              visitor,
              action,
              resourceName,
              projectName,
              resourcePath,
              simpleActivityLogs,
              time,
              projectId,
              id,
            }) => (
              <>
                <List.Item>
                  <List.Item.Meta
                    avatar={<Avatar src="https://joeschmoe.io/api/v1/random" />}
                    title={
                      <p className="activity-title">
                        <span className="activity-username">{visitor} </span>
                        {action}
                        <span>
                          <Link
                            onClick={() =>
                              handleResourceLinkClick(resourceName, projectId)
                            }
                            to={{
                              pathname: getResourceLinkPath(
                                resourceName,
                                projectId
                              ),
                              state: getResourceLinkState(resourceName),
                            }}
                          >
                            {resourceName}
                          </Link>
                        </span>
                        {action === 'CREATED' && resourceName === 'CLIENT'
                          ? 'with the name'
                          : ' for the'}

                        <Link
                          className="project-name"
                          onClick={() => {
                            dispatch(getProjectById(projectId))
                            // dispatch(getPredictionDetailsById(projectId))
                          }}
                          to={{
                            pathname: getProjectLinkPath(
                              resourceName,
                              projectId
                            ),
                            state: {
                              sidebarSelected: resourceName === 'USER' && '6',
                            },
                          }}
                        >
                          {projectName}
                        </Link>
                        {action === 'UPDATED' &&
                          resourceName !== 'SPECIAL_RATE' &&
                          resourceName !== 'RATE' &&
                          simpleActivityLogs?.length > 0 && (
                            <Button
                              className="link-btn"
                              type="link"
                              onClick={() => handleToggleExpanded(id)}
                              label={getExpandToggleLabels(expanded, id)}
                            />
                          )}
                      </p>
                    }
                  />
                  <div>{time}</div>
                </List.Item>

                {expanded.map((item) => {
                  if (item?.id === id) {
                    if (item?.value) {
                      return (
                        <div className="activity-discription">
                          <div className="activity-log">
                            {simpleActivityLogs?.map((item, index) => {
                              return (
                                <p>
                                  <strong>{item?.fieldName}</strong> :
                                  <span>{item?.oldValue}</span>
                                  -&gt;
                                  <span>{item?.newValue}</span>
                                </p>
                              )
                            })}
                          </div>
                        </div>
                      )
                    }
                  }
                })}
              </>
            )}
          />
        </Panel>
      </Collapse>
    </div>
  )
}

export default ListData
